function renderPaylands (country, field) {
  return '<div class="ui-form__row hidden"><div class="ui-form__field">' +
    '<style>#pl {min-height: 500px !important;width: 100% !important} @media (min-width: 512px) {#pl {min-height: 520px !important;}}</style>' +
    '<p style="margin: 0 auto 10px auto; color: gray">' + fields_json.params.for_fields.paylands + '</p>' +
    '<div id="paylands-container" style="margin: 0 !important;padding: 0 !important; background: #5bb73b;border-top: none;border-left: none;border-right: none;width: 100%">' +
    '<iframe id="pl"></iframe>' +
    '</div>' +
    '<div class="ui-form-field-error-message ui-form-field-error-message_ui-form hidden" style="position: relative;top: -8px;width: 300px;margin: 0 auto 12px;text-align: left !important;">' +
    field.error + '</div>' +
    '<div class="has_declined_paylands_shower" style="text-align: center;margin-top: 20px"><a id="has_declined_paylands" style="cursor: pointer">' + fields_json.params.for_fields.paylands_skip[0] + '</a></br>' + fields_json.params.for_fields.paylands_skip[1] + '</div>\n' +
    '</div></div>'
}

export { renderPaylands }
